/**
 * Klaviyo popup close fix — restores page scroll and click after dismiss.
 * Klaviyo sometimes leaves the body lock class and full-screen dialog in the DOM after close.
 */
(function () {
  'use strict';

  var BODY_LOCK_CLASS = 'klaviyo-prevent-body-scrolling';
  var CLEANUP_DELAY_MS = 450;

  function unlockPage() {
    document.body.classList.remove(BODY_LOCK_CLASS);
    document.documentElement.classList.remove(BODY_LOCK_CLASS);
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.documentElement.style.removeProperty('overflow');
  }

  function isKlaviyoFadeOutDialog(dialog) {
    if (!dialog) return false;
    var inlineStyle = dialog.getAttribute('style') || '';
    return inlineStyle.indexOf('klaviyo-fadeout') !== -1;
  }

  function hideStuckKlaviyoDialogs() {
    document.querySelectorAll('[role="dialog"][aria-modal="true"]').forEach(function (dialog) {
      if (!isKlaviyoFadeOutDialog(dialog)) return;

      dialog.style.display = 'none';
      dialog.style.pointerEvents = 'none';
      dialog.setAttribute('aria-hidden', 'true');
    });
  }

  function cleanupKlaviyoOverlay() {
    hideStuckKlaviyoDialogs();
    unlockPage();
  }

  function scheduleCleanup() {
    window.setTimeout(cleanupKlaviyoOverlay, CLEANUP_DELAY_MS);
  }

  function isKlaviyoCloseTrigger(target) {
    if (!target || !target.closest) return false;

    return !!(
      target.closest('.klaviyo-close-form') ||
      target.closest('.klaviyo-form-button')
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      if (isKlaviyoCloseTrigger(event.target)) {
        scheduleCleanup();
      }
    },
    true
  );

  document.addEventListener(
    'animationend',
    function (event) {
      var animationName = event.animationName || '';
      if (animationName.indexOf('klaviyo-fadeout') === -1 && animationName.indexOf('klaviyo-fadeinup') === -1) {
        return;
      }

      if (!event.target.closest('[role="dialog"]')) return;

      window.setTimeout(cleanupKlaviyoOverlay, 50);
    },
    true
  );

  function watchBodyScrollLock() {
    if (!document.body.classList.contains(BODY_LOCK_CLASS)) return;

    var dialogs = document.querySelectorAll('[role="dialog"][aria-modal="true"]');
    var hasVisibleOpenDialog = false;

    dialogs.forEach(function (dialog) {
      if (dialog.getAttribute('aria-hidden') === 'true') return;
      if (isKlaviyoFadeOutDialog(dialog)) return;

      var computed = window.getComputedStyle(dialog);
      if (computed.display !== 'none' && computed.visibility !== 'hidden') {
        hasVisibleOpenDialog = true;
      }
    });

    if (!hasVisibleOpenDialog) {
      cleanupKlaviyoOverlay();
    }
  }

  var bodyObserver = new MutationObserver(watchBodyScrollLock);

  function startObservers() {
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'style') return;

        var target = mutation.target;
        if (!target.getAttribute || target.getAttribute('role') !== 'dialog') return;

        if (isKlaviyoFadeOutDialog(target)) {
          scheduleCleanup();
        }
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  if (document.body) {
    startObservers();
  } else {
    document.addEventListener('DOMContentLoaded', startObservers);
  }
})();
